import { Container, Group, Button, Image } from '@mantine/core';
import brosurIcon from '../../assets/images/Button-icon-Brosur.png';
import viewImage from '../../assets/images/Button-icon-3D.png';
const ButtonCompo = () => {
  return (
    <div>
      <Container mb={40}>
        <Group>
          <Button color="teal.9" radius="xl">
            <Image src={brosurIcon} width={20} mr={10} />
            Brosur
          </Button>
          <Button color="teal.9" radius="xl">
            <Image src={viewImage} width={25} mr={10} />
            360 View
          </Button>
        </Group>
      </Container>
    </div>
  );
};

export default ButtonCompo;
